import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const BooleanCell = ({ name, row }) => {
    const translate = useComponentTranslations();

    return row[name] ? translate('table.cell.boolean.yes') : translate('table.cell.boolean.no');
};
